import React, { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert'
import {
  updateMenuDisplay,
} from '../../../states/containers/setting/systemSlice'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-common-types'
import LoadingSquare from '../common/LoadingSquare'

const MenuDisplay: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    system,
  } = useSelector((state: RootState) => (state))

  const [displayMenu, setDisplayMenu] = useState<boolean>(!!system.menu_display)
  const [isChange, setIsChange] = useState<boolean>(false)

  const canSubmit = () => {
    if (displayMenu === !!system.menu_display) {
      setIsChange(false)
    } else {
      setIsChange(true)
    }
  }

  useEffect(() => {
    if (system.menu_display === undefined) return
    // eslint-disable-next-line no-unneeded-ternary
    setDisplayMenu(system.menu_display ? true : false)
    canSubmit()
  }, [system.menu_display])

  useEffect(() => {
    canSubmit()
  }, [displayMenu])

  const handleDisplayMenu = () => {
    if (!isChange) return
    dispatch(
      updateMenuDisplay(
        { visible: displayMenu },
        () => {
          alert.success(t('form.alert.updated'))
        },
      ),
    )
  }

  return (
    <>
      {
        system.isLoading ? (
          <LoadingSquare>
            <>
              設定を読み込んでいます…
            </>
          </LoadingSquare>
        ) : (
          <>
            <div
              className={`graphical_check_box${!displayMenu ? " selected" : ""}`}
              onClick={() => setDisplayMenu(!displayMenu)}
              role="none"
            >
              <FontAwesomeIcon
                icon={['far', `${!displayMenu ? 'check-square' : 'square'}` as IconName]}
                className={`icon ${!displayMenu ? "checked" : "no_check"}`}
              />
              <div>
                <div className="check_box_title">
                  {t('setting.common.menu_display.label')}
                </div>
                <div className="check_box_description">
                  QaseeClientの操作を制限して、ユーザによる計測停止を行えないようにできます
                </div>
              </div>
            </div>
            <button
              type="button"
              className="mt-4 button"
              onClick={handleDisplayMenu}
              disabled={!isChange}
            >
              {t('setting.common.menu_display.button_text')}
            </button>
          </>
        )
      }
    </>
  )
}

export default MenuDisplay
